<template>
<el-radio-group v-model="completed" size="small" @change="onSelectChanged">
  <el-radio-button :label="false">审核前</el-radio-button>
  <el-radio-button :label="true">审核后</el-radio-button>
  <el-radio-button label="isFuse" v-if="isShowFuse">混合</el-radio-button>
</el-radio-group>
</template>

<script>
export default {
  name: 'CompletedQuery',
  props: {
    value: {
      type: Boolean
    },
    isShowFuse: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      completed: this.value
    }
  },
  methods: {
    onSelectChanged (completed) {
      this.$emit('input', completed)
      this.$emit('change', completed)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/Query/CompletedQuery.vue